import { Pipe, PipeTransform } from '@angular/core';
import { Request } from '../../classes/request';

@Pipe({
  name: 'idFilter',
  pure: false
})
export class IdFilterPipe implements PipeTransform {

  transform(requestList: Array<Request>, filterValue: string): any {
    if (!requestList || !filterValue) {
      return requestList;
    }
    const normalizedFilter = filterValue.toString().trim().toLowerCase();
    return requestList.filter(request =>
      String(request.IDRequest ?? '').toLowerCase().indexOf(normalizedFilter) !== -1
    );
  }

}
